/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';
import TransferARModalController from '../../Modals/ActionRequiredModals/TransferARModal/TransferARModalController';
import { useAppSelector } from '../../../infra/hooks';
import _ from 'lodash';
import { useTranslate } from '../../../hooks';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { DateField } from '../../../components';

interface Propval {
  trans: any;
}

const Transfer = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [fullData, setFullData] = useState<any>({});

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );

  const handleTransferView = (transfer: any) => {
    setFullData(transfer);
  };

  const tableColumns: any = [
    {
      field: 'empId',
      headerName: trans('Emp Id'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'empName',
      headerName: trans('Emp Name'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return <EmployeeNamePic name={params?.row?.empName} picture="" />;
      },
    },
    {
      field: 'transferFrom',
      headerName: trans('Transfer From'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'transferTo',
      headerName: trans('Transfer To'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'transferDate',
      headerName: trans('Transfer Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField
          value={params?.row?.transferDate}
          format={baseDateFormatting}
        />
      ),
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handleTransferView(params?.row?.fullData);
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = _.map(storedARData, (data: any) => {
    return {
      id: data?.id,
      empId: `#${data?.staff_id}`,
      empName: `${data?.first_name} ${data?.last_name}`,
      empPic: data?.profile_pic,
      transferFrom: data?.pre_company,
      transferTo: data?.company,
      transferDate: data?.transfer_date,
      fullData: data,
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          disableSelectionOnClick
          disableColumnMenu
          localeText={isRTL ? arabicDataGrid : undefined}
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <TransferARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          fullData={fullData}
        />
      )}
    </>
  );
};

export default Transfer;
